module.exports = __webpack_public_path__ + "media/src/images/mails/linkedin-53b43ec17ee1774730306597bd8f599e.png";